import { render, staticRenderFns } from "./aboutMe.vue?vue&type=template&id=59095100&scoped=true&"
import script from "./aboutMe.vue?vue&type=script&lang=js&"
export * from "./aboutMe.vue?vue&type=script&lang=js&"
import style0 from "./aboutMe.vue?vue&type=style&index=0&id=59095100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59095100",
  null
  
)

export default component.exports